// extracted by mini-css-extract-plugin
export default {"alert":"AmFXg5dtdt"};